export default __webpack_public_path__ + "static/media/MetaZooTournamentPolicy.e155e688.pdf";